import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

import setModule from "./setModule";
import setArticleTemplate from "./setArticleTemplate";
import _getSource from "./_getSource";
import initList from "./initList";
import replicant from "./replicant";
import pager from "./pager";

/**
 * Klass.VuwColony.js
 * TyrellModuleで取得したデータの表示用Vuwを定義
 * @options
 * ...TyrellModule.prototype._enableSetOptions
 * - {object} module: データ取得用モジュールか、モジュール生成用のオブジェクト (+ dataKey)
 * - {boolean} autoLoad: 設定データのロードを自動的に行うかどうか
 * - {boolean} showPager: ページャーの表示ON/ OFF
 * - {function} initArticle: 記事の生成関数 arguments = [item, config, $item, module]
*/
vuwer.appendKlass("VuwColony", {
	// ** コンストラクタの引数の初期値 **
	_defaultOptions: {
		// データ取得用モジュール（TyrellModule） || モジュール生成用オブジェクト
		module: null,
		
		// moduleが指定されている場合に設定データのロードを自動的に行うかどうか
		// （値がobjectの場合はTyrellModule.prototype.load関数の第一引数とする）
		autoLoad: true,
		
		// 記事のテンプレートのセレクタ（未指定の場合は最後の子要素がテンプレートとなる）
		articleTemplate: "",
		
		// ページ指定のクエリ文字列
		pageQuery: "page",
		
		// ページャーの表示ON/OFF（infiniteがtrueの場合は強制OFF）
		showPager: true,
		
		// ページャーから除外するクエリ文字列
		excludeQueryFromPager: [],
		
		// 無限スクロールのON/OFF
		infinite: false,
		
		// 記事の生成関数 (falseを返すと非表示) ※this: vuwReplicant
		initArticle(item, config, $article, module) {},
		
		// リスト更新時の表示切り替えまでの最小時間（ミリ秒）
		minimumRenderingTime: 400
	},
	
	setModule,
	setArticleTemplate,
	_getSource,
	initList,
	...replicant,
	...pager,
	
	/**
	 * [コンストラクタ]
	 *
	 * @param {Object} [opt]
	 * @returns this | false
	 */
	_initialize(opt) {
		if( u_.isObject(opt) ) {
			// onReadyFirstが指定されている場合は退避
			if( u_.isFunction(opt.onReadyFirst) ) {
				this._onReadyFirst = opt.onReadyFirst;
				delete opt.onReadyFirst;
			}
			
		} else {
			opt = {};
		}
		
		opt = { ...this._defaultOptions, ...opt };
		
		if( Klass("VuwColony").parent._initialize.call(this, opt) ) {
			if( u_.isObject(this.module) ) {
				if( this.module instanceof Klass("TyrellModule") ) {
					this.setModule(this.module);
				} else
				if(this.module.dataKey) {
					const dataKey = this.module.dataKey;
					delete this.module.dataKey;
					this.setModule( Klass.new_("TyrellModule", dataKey, this.module) );
				}
			}
			
			if(
				u_.hasProperty(this, "module") &&
				!( this.module instanceof Klass("TyrellModule") )
			) {
				delete this.module;
			}
			
			if(this.module && this.autoLoad) {
				this._loadPromise = this.module.loadConfig(this.autoLoad);
			}
			
			(this.showPager && this.infinite) && (this.showPager = false);
			if(this.showPager) {
				// [add pager]
				this.add("pager", {
					vuwType: "pager",
					pageQuery: this.pageQuery,
					selector() {
						if(this.container.$self) {
							return $("<var/>").attr({
								"data-vuw": this.name
							}).insertAfter(this.container.$self);
						}
					}
				});
			}
			
			return this;
			
		} else {
			return false;
		}
	},
	
	/**
	 * getReady時に最初に実行される関数
	 *
	 * @param {$Object} $self
	 * @returns Promise
	 */
	async onReadyFirst($self) {
		const args = u_.getAsArray(arguments);
		
		if($self) {
			$self.addClass("vuw-colony");
			this.setArticleTemplate(this.articleTemplate);
		}
		
		if( u_.hasProperty(this, "_loadPromise") ) {
			args.push( await this._loadPromise );
		}
		
		!!$self && $self.addClass("is-initialized");
		
		if( u_.isFunction(this._onReadyFirst) ) {
			return this._onReadyFirst(...args);
		}
	},
});
